<template>
  <div class="vx-col w-full lg:w-1/2 mb-base">
    <vx-card title="Project Status">
      <template slot="actions">
        <change-time-duration-dropdown
          @timeDurationChanged="handleTimeDuration"
        />
      </template>

      <div slot="no-body">
        <vue-apex-charts
          type="donut"
          height="340"
          class="mb-12 mt-4"
          :options="options"
          :series="series"
        />
      </div>

      <ul>
        <li
          v-for="(data, index) in analyticsData"
          :key="data.key"
          class="flex mb-3"
        >
          <span class="flex items-center">
            <span
              class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
              :class="`border-${color[index]}`"
            ></span>
            <span class="font-semibold">{{ data.key }}</span>
          </span>
          <div class="ml-auto flex -mr-1">
            <span class="mr-1">{{ data.value }}</span>
          </div>
        </li>
      </ul>
    </vx-card>
  </div>
</template>
<script>
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";

import VueApexCharts from "vue-apexcharts";
var default_options = {
  labels: [],
  dataLabels: {
    enabled: false,
  },
  legend: { show: false },
  chart: {
    offsetY: 30,
    type: "donut",
    toolbar: {
      show: false,
    },
  },
  stroke: { width: 0 },
  colors: [
    "#2ec1ac",
    "#cd0a0a",
    "#c87941",
    "#3ec1d3",
    "#393b44",
    "#2ec1ac",
    "#cd0a0a",
    "#c87941",
    "#C85A17",
  ],
  fill: {
    type: "gradient",
    gradient: {
      gradientToColors: [
        "#2ec1ac",
        "#cd0a0a",
        "#c87941",
        "#3ec1d3",
        "#393b44",
        "#2ec1ac",
        "#cd0a0a",
        "#c87941",
        "#C85A17",
      ],
    },
  },
};

// var data_test = Array([
//   { key: "New", counts: "500", percentage: "28" },
//   { key: "New1", counts: "500", percentage: "28" },
//   { key: "New2", counts: "500", percentage: "28" },
//   { key: "New3", counts: "500", perc[]entage: "28" },
//   { key: "New4", counts: "500", percentage: "28" }
// ]);

export default {
  components: {
    VueApexCharts,
    ChangeTimeDurationDropdown,
  },

  data() {
    return {
      options: {},
      input: {},
      series: [],
      analyticsData: [],
      percentage: [],
      color: [
        "success",
        "danger",
        "warning",
        "primary",
        "info",
        "success",
        "danger",
        "warning",
        "primary",
        "info",
      ],
      comparedResult: [],
    };
  },
  async mounted() {
    this.getProjectDashboardData();
  },
  methods: {
    async getProjectDashboardData() {
      let response = await this.getHTTPPostResponse(
        "/dashboard/projects",
        this.input
      );
      if (response) {
        let data_response = response.data["project_details"];

        var lables = [];
        var percentage = [];

        data_response.forEach((element) => {
          lables.push(element.key);
          percentage.push(element.percentage);
        });

        this.series = percentage;
        this.analyticsData = data_response.map((v) => ({
          ...v,
          key:
            this.isUserType("CL") && v.key === "Sent to Client"
              ? "Report Reviewed"
              : v.key,
        }));
        default_options.labels = lables;
        this.options = default_options;
      }
    },
    handleTimeDuration(time) {
      this.input = {
        time: time,
      };
      this.getProjectDashboardData();
    },
  },
};
</script>
